import { render } from "./DiscountCodeModal.vue?vue&type=template&id=316392fb"
import script from "./DiscountCodeModal.vue?vue&type=script&lang=js"
export * from "./DiscountCodeModal.vue?vue&type=script&lang=js"

import "./DiscountCodeModal.vue?vue&type=style&index=0&id=316392fb&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__